// extracted by mini-css-extract-plugin
module.exports = {"container":"SnackBar_container__0vMZ3","variant--outlined":"SnackBar_variant--outlined__1njJk"};